import Router from 'next/router';
import getIsResponseEnded from './getIsResponseEnded';

function isTruthyQueryParameter(parameter) {
  return /^(true|1)$/.test(parameter);
}

var isomorphicRedirect = function isomorphicRedirect(_ref) {
  var redirectPath = _ref.redirectPath,
      _ref$disabledClientSi = _ref.disabledClientSide,
      disabledClientSide = _ref$disabledClientSi === void 0 ? false : _ref$disabledClientSi,
      _ref$disabledServerSi = _ref.disabledServerSide,
      disabledServerSide = _ref$disabledServerSi === void 0 ? false : _ref$disabledServerSi,
      _ref$statusCode = _ref.statusCode,
      statusCode = _ref$statusCode === void 0 ? 307 : _ref$statusCode,
      ctx = _ref.ctx;

  if (ctx) {
    var res = ctx.res,
        errorCodeRedirectDisabled = ctx.query.errorCodeRedirectDisabled;
    var disabled = disabledServerSide;

    if (typeof errorCodeRedirectDisabled === 'string') {
      disabled = isTruthyQueryParameter(errorCodeRedirectDisabled);
    }

    if (res && !disabled) {
      var responseEnded = getIsResponseEnded(ctx);

      if (!responseEnded) {
        res.writeHead(statusCode, {
          Location: redirectPath
        });
        res.end();
      }
    }
  } else {
    if (process.browser) {
      var _Router$router;

      var _errorCodeRedirectDisabled = Router === null || Router === void 0 ? void 0 : (_Router$router = Router.router) === null || _Router$router === void 0 ? void 0 : _Router$router.query.disableErrorCodeRedirect;

      var _disabled = disabledClientSide;

      if (typeof _errorCodeRedirectDisabled === 'string') {
        _disabled = isTruthyQueryParameter(_errorCodeRedirectDisabled);
      }

      if (!_disabled) {
        Router.replace(redirectPath);
      }
    }
  }
};

export default isomorphicRedirect;